import { provideSignalFormsConfig } from '@angular/forms/signals';

export const signalFormsConfig = provideSignalFormsConfig({
  classes: {
    'ng-valid': ({ state }) => state().valid(),
    'ng-invalid': ({ state }) => state().invalid(),
    'ng-touched': ({ state }) => state().touched(),
    'ng-dirty': ({ state }) => state().dirty(),
    'ng-pending': ({ state }) => state().pending(),
  },
});
